<template>
  <basic-container>
    <avue-crud
      :option="option1"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <!--自定义查看按钮-->
      <template slot-scope="{ row }" slot="menu">
        <el-button
          type="text"
          icon="el-icon-view"
          size="small"
          plain
          style="border: 0; background-color: transparent !important;"
          @click.stop="handleDataScope(row)"
          >查看
        </el-button>
        <el-button
          type="text"
          icon="el-icon-back"
          size="small"
          plain
          style="border: 0; background-color: transparent !important;"
          @click.stop="auditClick(row)"
          >审核
        </el-button>
        <el-button
          type="text"
          icon="el-icon-back"
          size="small"
          plain
          style="border: 0; background-color: transparent !important;"
          @click.stop="rejectClick(row)"
          >拒绝
        </el-button>
      </template>
    </avue-crud>

    <!--查看详情弹出框-->
    <el-drawer
      :visible.sync="drawerVisible"
      :direction="direction"
      :before-close="handleDrawerClose"
      :append-to-body="true"
      v-model="formScope"
      size="1500px"
    >
      <el-container>
        <el-header height="200px">
          <!--退款交易订单表格-->
          <avue-crud
            :option="optionScope1"
            :table-loading="scopeLoading1"
            :data="dataScope1"
            v-model="formScope1"
            ref="crudScope1"
            @on-load="onLoadScope1"
            @refresh-change="onLoadScope1"
          >
          </avue-crud>
        </el-header>
        <el-main>
          <!--退款交易订单详情表格-->
          <avue-crud
            :option="optionScope2"
            :table-loading="scopeLoading2"
            :data="dataScope2"
            :page="pageScope2"
            :permission="permissionList"
            :span-method="spanMethod"
            v-model="formScope2"
            ref="crudScope2"
            @current-change="currentChangeScope2"
            @size-change="sizeChangeScope2"
            @on-load="onLoadScope2"
            @refresh-change="onLoadScope2"
          >
          </avue-crud>
        </el-main>
      </el-container>
    </el-drawer>
  </basic-container>
</template>

<script>
import option1 from '@/api/v4ward/pay/payrefundaudit-option1';
import option2 from '@/api/v4ward/pay/payrefundaudit-option2';
import option3 from '@/api/v4ward/pay/payrefundaudit-option3';
import {
  add,
  getOrderDetail,
  getAuditDetail,
  getDetail,
  getList,
  remove,
  update,
  reject,
  audit,
} from '@/api/v4ward/pay/payrefundaudit';
import { mapGetters } from 'vuex';

export default {
  data() {
    const date = new Date();
    let defaultTimeEnd = this.dayjs(date).format('YYYY-MM-DD HH:mm:ss');
    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
    let defaultTimeStart = this.dayjs(date).format('YYYY-MM-DD') + ' 00:00:00';

    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option1: {
        sarchShow: true,
        searchMenuSpan: 6,
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',

        viewBtn: false,
        selection: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,

        column: [
          {
            label: '商户退款单号',
            prop: 'mchRefundNo',
            rules: [
              {
                required: true,
                message: '请输入商户退款单号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付渠道',
            prop: 'payPlatform',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payChannel',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入支付渠道',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付场景',
            prop: 'payScene',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payScene',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            width: 120,
            rules: [
              {
                required: false,
                message: '请输入支付场景',
                trigger: 'change',
              },
            ],
          },
          {
            label: '退款金额(元)',
            prop: 'refundFee',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入退款金额(元)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '退款状态',
            prop: 'refundStatus',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=refundStatus',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入退款状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '申请人',
            prop: 'refundApplyName',
            rules: [
              {
                required: true,
                message: '请输入申请人',
                trigger: 'change',
              },
            ],
          },
          {
            label: '退款申请时间',
            prop: 'refundApplyTime',
            searchLabelWidth: 100,
            startPlaceholder: defaultTimeStart,
            endPlaceholder: defaultTimeEnd,
            search: true,
            type: 'datetime',
            searchRange: true,
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            searchSpan: 8,

            rules: [
              {
                required: true,
                message: '请输入退款申请时间',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],

      // 详情弹窗
      drawerVisible: false,
      direction: 'rtl',
      mchOrderNo: null,
      mchRefundNo: null,
      //详情主表
      formScope1: {},
      optionScope1: option2,
      scopeLoading1: true,
      dataScope1: [],

      //详情明细表
      pageScope2: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      formScope2: {},
      optionScope2: option3,
      scopeLoading2: true,
      dataScope2: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.payrefundaudit_add, false),
        viewBtn: this.vaildData(this.permission.payrefundaudit_view, false),
        delBtn: this.vaildData(this.permission.payrefundaudit_delete, false),
        editBtn: this.vaildData(this.permission.payrefundaudit_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      const { refundApplyTime } = this.query;

      let values = {
        ...this.query,
      };

      if (refundApplyTime) {
        values = {
          ...this.query,
          refundApplyTimeStart: refundApplyTime[0],
          refundApplyTimeEnd: refundApplyTime[1],
        };
        values.refundApplyTime = null;
      }

      this.loading = true;

      if (!values.refundApplyTimeStart) {
        const date = new Date();
        values.refundApplyTimeEnd = this.dayjs(date).format('YYYY-MM-DD HH:mm:ss');
        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
        values.refundApplyTimeStart = this.dayjs(date).format('YYYY-MM-DD') + ' 00:00:00';
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, values))
        .then()
        .then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
        });
    },

    //查看详情弹出框表格
    handleDataScope(row) {
      this.drawerVisible = true;
      this.mchOrderNo = row.mchOrderNo;
      this.mchRefundNo = row.mchRefundNo;
      this.onLoadScope1();
      this.onLoadScope2();
    },
    handleDrawerClose(hide) {
      hide();
    },
    //详情主表
    onLoadScope1() {
      let param = {
        mchOrderNo: this.mchOrderNo,
      };
      this.scopeLoading1 = true;
      getOrderDetail(Object.assign({ current: null, size: null }, param))
        .then()
        .then(({ data }) => {
          let dataScope1Tmp = [];
          dataScope1Tmp.push(data);
          this.dataScope1 = dataScope1Tmp;
          this.scopeLoading1 = false;
        });
    },
    //详情明细表
    currentChangeScope2(currentPage) {
      this.pageScope2.currentPage = currentPage;
    },
    sizeChangeScope2(pageSize) {
      this.pageScope2.pageSize = pageSize;
    },
    onLoadScope2(page) {
      page = page || this.pageScope2;
      let param = {
        mchOrderNo: this.mchOrderNo,
        mchRefundNo: this.mchRefundNo,
      };

      this.scopeLoading2 = true;
      getAuditDetail(Object.assign({ current: page.currentPage, size: page.pageSize }, param))
        .then()
        .then(({ data }) => {
          this.pageScope2.total = data.total;
          this.dataScope2 = data.records;
          this.scopeLoading2 = false;
        });
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 8) {
        if (rowIndex % 10 == 0) {
          return {
            rowspan: 10,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },

    //审核
    auditClick(row) {
      this.$confirm('审核通过, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let param = {
            mchRefundNo: row.mchRefundNo,
          };
          audit(param).then(
            () => {
              this.onLoad();
              this.$message({
                type: 'success',
                message: '审核通过成功!',
              });
            },
            (error) => {
              this.onLoad();
              done();
              console.log(error);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审核',
          });
        });
    },

    //拒绝
    rejectClick(row) {
      this.$prompt('请填写审核拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          if (null == value) {
            this.$message({
              type: 'warning',
              message: '请填写拒绝原因',
            });
            return;
          }
          let param = {
            mchRefundNo: row.mchRefundNo,
            rejectDesc: value,
          };
          reject(param).then(
            () => {
              this.onLoad();
              this.$message({
                type: 'success',
                message: '审核拒绝成功!',
              });
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审核拒绝',
          });
        });
    },
  },
};
</script>

<style scoped>
.avue-crud__menu {
  min-height: 0px;
}
.el-main {
  padding: 0 20px !important;
}
</style>
